export default function PHP_AjaxIntro() {
  return (
    <div>
      <h1>PHP_AjaxIntro</h1>
    </div>
  );
}
